/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Identity_DismissInputs */

const en_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not interested`)
};

const de_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Interesse`)
};

const zh_tw_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我不感興趣`)
};

const zh_cn_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我不感兴趣`)
};

const es_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No me interesa`)
};

const fr_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça ne m'intéresse pas`)
};

const it_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non mi interessa`)
};

const pt_br_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não tenho interesse`)
};

const ja_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`興味ありません`)
};

const ko_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`관심 없어요`)
};

const ru_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мне не интересно`)
};

const th_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สนใจ`)
};

const tr_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlgilenmiyorum`)
};

const ar_identity_dismiss = /** @type {(inputs: Identity_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يهمني`)
};

/**
* | output |
* | --- |
* | "Not interested" |
*
* @param {Identity_DismissInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const identity_dismiss = /** @type {((inputs?: Identity_DismissInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Identity_DismissInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_identity_dismiss(inputs)
	if (locale === "de") return de_identity_dismiss(inputs)
	if (locale === "zh_tw") return zh_tw_identity_dismiss(inputs)
	if (locale === "zh_cn") return zh_cn_identity_dismiss(inputs)
	if (locale === "es") return es_identity_dismiss(inputs)
	if (locale === "fr") return fr_identity_dismiss(inputs)
	if (locale === "it") return it_identity_dismiss(inputs)
	if (locale === "pt_br") return pt_br_identity_dismiss(inputs)
	if (locale === "ja") return ja_identity_dismiss(inputs)
	if (locale === "ko") return ko_identity_dismiss(inputs)
	if (locale === "ru") return ru_identity_dismiss(inputs)
	if (locale === "th") return th_identity_dismiss(inputs)
	if (locale === "tr") return tr_identity_dismiss(inputs)
	return ar_identity_dismiss(inputs)
});